import React, { Component } from 'react';
import PropTypes from 'prop-types';

class MustHaveReadText extends Component {
  static propTypes = {
    content: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    IsTextRead: PropTypes.func,
  };

  static defaultProps = {
    content: '',
    IsTextRead: () => {}
  };

  constructor(props) {
    super(props);
    this.container = React.createRef();
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    this.enableContinueButton();
    window.addEventListener('resize', this.handleResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }

  handleScroll = (e) => {
    const element = e.target;
    const { IsTextRead } = this.props;
    // + 1 resolves issue in IE where clientHeight is 1 pixel less than scrollHeight when the content is just long enough to fit in container
    if (Math.floor(element.scrollHeight - element.scrollTop) <= element.clientHeight + 1) {
      IsTextRead(true);
    }
  };

  handleResize() {
    this.enableContinueButton();
  }

  enableContinueButton() {
    const { IsTextRead } = this.props;

    // + 1 resolves issue in IE where clientHeight is 1 pixel less than scrollHeight when the content is just long enough to fit in container
    if ((this.container.current.clientHeight + 1) >= this.container.current.scrollHeight) {
      IsTextRead(true);
    }
  }

  render() {
    const { content } = this.props;

    return (
      <React.Fragment>
        <div className="must-have-read-text" onScroll={ this.handleScroll }>
          <div className="scroll-container" ref={ this.container }>
            { content }
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default MustHaveReadText;
